export default __webpack_public_path__ + "static/media/grafema_gim-tonico_07.f66412e5.jpg";